export function createQueryKeys(queryDef, schema) {
    const baseKey = [queryDef];
    if (!schema) {
        return { _def: baseKey };
    }
    const result = {
        _def: baseKey,
    };
    for (const key in schema) {
        const schemaValue = schema[key];
        if (typeof schemaValue === "function") {
            result[key] = (...args) => {
                const options = schemaValue(...args);
                return {
                    queryKey: [...baseKey, ...options.queryKey],
                    queryFn: options.queryFn,
                };
            };
        }
    }
    return result;
}
